import React, { Component } from 'react'
import { translate } from '../../Services/translation';

class DeliveryWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zip: null,
            isLoading: false,
            error: '',
            responseData: null
        }
        this.myRef = React.createRef();
    }

    componentWillReceiveProps(props) {
        if (props.zip && props.zip !== null && props.zip !== '') {
            const { getDeliveryConfig, zip, currency, country, orderRows } = props;
            if (this.state.zip !== zip) {
                let config = {
                    currency: currency,
                    language: country.toLowerCase(),
                    tocountry: country,
                    weight: orderRows.map(row => row.weight * row.quantity).reduce((partial_sum, a) => partial_sum + a),
                    tozipcode: zip
                }
                if (this.myRef.current && window.UnifaunCheckout) {
                    this.widget = window.UnifaunCheckout.createAt(this.myRef.current, {
                        language: country.toLowerCase(),
                        resultCallback: this.widgetChanged.bind(this),
                        useIcons: true,
                        iconsBaseUrl: "https://api.unifaun.com/rs-extapi/v1/delivery-checkouts-widget/logos"
                    });
                    this.widget.installCSS();
    
                    this.setState({
                        isLoading: true,
                        error: '',
                    });
                    getDeliveryConfig(config, this.widget).then((response) => {
                        if (response && response.options && response.options.length === 0) {
                            this.setState({
                                error: translate('checkout.delivery.no-available-option'),
                                isLoading: false,
                                responseData: null
                            });
                        } else {
                            this.setState({
                                error: '',
                                isLoading: false,
                                responseData: response.options
                            }, () => {
                                this.widget.updateList(response)
                            });
                        }
                    }).catch((e) => {
                        console.log(`Delivery widget error: ${e.message}`);
                        this.setState({ isLoading: false });
                    });
                }
            }
            this.setState({ zip: props.zip });
        }
    }

    widgetChanged() {
        const { onChange } = this.props;
        const result = this.widget.getResult();
        const optionData = this.state.responseData.find(option => option.id === result.selectedOptionId);
        
        const payload = {
            selectedOptionId: result.selectedOptionId,
            selectedOptionName: optionData.name,
            price: result.price,
            deliveryCheckoutId: result.deliveryCheckoutId,
            agent: result.agent
        };

        onChange(payload);
    }

    render() {
        let { isLoading, zip, error } = this.state;
        let spinner = <div><i className="fas fa-spinner fa-spin fa-5x"></i></div>;
        let unifaun = <div ref={this.myRef}></div>;
        let errormsg = error !== '' ? <div className="delivery-error-message">{error}</div> : null;

        return (
            <div className="columns unifaun-container">
                {isLoading ? spinner : unifaun}
                {errormsg}
            </div>
        )
    }
}

export default DeliveryWidget;
